import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ProtectedRoute } from './components/protected.route'

import Home from './pages/Home'
import Layout from './components/Layout'

import Login from './pages/Login'
import Noticias from './pages/Noticias'
import Eventos from './pages/Eventos'

import Clima from './pages/DesafioClima'
import ClimaInfo from './pages/DesafioClimaInfo'

import Residuos from './pages/ResiduosSS'
import ResiduosInfo from './pages/ResiduosSSInfo'


import Energia from './pages/DesafioEnergia'
import EnergiaInfo from './pages/DesafioEnergiaInfo'


import Pagina from './pages/Pagina'



import Compras from './pages/DesafioCompras'
import ComprasInfo from './pages/DesafioComprasInfo'

import Paginas from './pages/Paginas'
import AdesaoIndividual from './pages/AdesaoIndividual'
import AdesaoInstitucional from './pages/AdesaoInstitucional'

import Usuario from './pages/Usuario'
import Usuarios from './pages/Usuarios'

import AdesaoInstitucionalInfo from './pages/AdesaoInstitucionalInfo'
import AdesaoIndividualInfo from './pages/AdesaoIndividualInfo'
import NoticiaEdit from './pages/NoticiaEdit'
import Evento from './pages/Evento'
import Biblioteca from './pages/Biblioteca'
import BibliotecaEdit from './pages/BibliotecaEdit'

import FaleConosco from './pages/FaleConosco'
import FaleConoscoEdit from './pages/FaleConoscoEdit'

import FiqueInformado from './pages/FiqueInformado'
import FiqueInformadoEdit from './pages/FiqueInformadoEdit'
import Calendario from './pages/Calendario'

import API from './pages/API'
import Indicadores from './pages/Indicadores'

import AmbienteProvider from './context/ambienteContext'
import EnergiaCompradaProvider from './context/energiaCompradaContext'
import EnergiaGeradaProvider from './context/energiaGeradaContext'
import EnergiaCombustivelProvider from './context/energiaCombustivelContext'
import EnergiaIluminacaoProvider from './context/energiaIluminacaoContext'
import EnergiaHvacProvider from './context/energiaHvacContext'
import EnergiaHvacIndiretaProvider from './context/energiaHvacIndiretaContext'
import EnergiaHvacDiretaProvider from './context/energiaHvacDiretaContext'

import EnergiaRefrigeracaoProvider from './context/energiaRefrigeracaoUnitContext'
import EnergiaRefrigeracaoCamProvider from './context/energiaRefrigeracaoCamContext'

import EnergiaAquecimentoProvider from './context/energiaAquecimentoContext'
import EnergiaIdentificacaoProvider from './context/energiaIdentificacaoContext'


import TabelaGestaoProvider from './context/GestaoPendenciasContext'
import EnunciadoProvider from './context/enunciadoContext'
import VerificaDesafioProvider from './context/verificaDesafioContext'
import SecaoEnunciadoProvider from './context/secaoEnunciadoContext'
import GeradoresProvider from './context/geradoresEstacionariosContext'
import SadtProvider from './context/SadtContext'
import EmailVerProvider from './context/emailVerContext'

import PerfilAnual from './pages/PerfilAnual'
import Editor from './pages/Editor'

import Tokens from './pages/Tokens'
import Manifesto from './pages/Manifesto'
import GestaoMembros from './pages/GestaoMembros'
import HouseKeeper from './pages/HouseKeeper'

import ResiduosDashboard from './pages/ResiduosDashboard'

import { QueryClient, QueryClientProvider } from 'react-query'

const Routes = () => {


    return (

        <QueryClientProvider client={ new QueryClient()}>
                

            <Switch>


                <Route path='/' exact component={Login} />

                <Route path='/Editor' exact component={Editor} />

                <Layout>

                    <TabelaGestaoProvider>

                        <AmbienteProvider>
                        <EnergiaCompradaProvider>
                        <EnergiaGeradaProvider>
                        <EnergiaCombustivelProvider>
                        <EnergiaIluminacaoProvider>
                        <EnergiaHvacProvider>
                        <EnergiaHvacIndiretaProvider>
                        <EnergiaHvacDiretaProvider>
                        <EnergiaRefrigeracaoProvider>
                        <EnergiaRefrigeracaoCamProvider>
                        <EnergiaAquecimentoProvider>
                        <EnergiaIdentificacaoProvider>
                        <EnunciadoProvider>
                        <VerificaDesafioProvider>
                        <SecaoEnunciadoProvider>
                        <GeradoresProvider>
                        <SadtProvider>
                        <EmailVerProvider>


                            <ProtectedRoute path='/Dashboard' exact component={Home} />
                            <ProtectedRoute path='/Noticias' exact component={Noticias} />
                            
                            <ProtectedRoute path='/DesafioClima' exact component={Clima} />
                            <ProtectedRoute path='/DesafioClima/:adesao_institucional_id' exact component={ClimaInfo} />

                            <ProtectedRoute path='/Residuos/Dados' exact component={Residuos} />
                            <ProtectedRoute path='/Residuos/Dashboard' exact component={ResiduosDashboard} />
                            <ProtectedRoute path='/ResiduosSS/:adesao_institucional_id' exact component={ResiduosInfo} />
                        
                            

                            <ProtectedRoute path='/DesafioEnergia' exact component={Energia} />

                            <ProtectedRoute path='/DesafioEnergia/:adesao_institucional_id' exact component={EnergiaInfo} />

                        
                            
                            <ProtectedRoute path='/DesafioCompras' exact component={Compras} />
                            <ProtectedRoute path='/DesafioCompras/:adesao_institucional_id' exact component={ComprasInfo} />
                            
                            <ProtectedRoute path='/Paginas' exact component={Paginas} />
                            <ProtectedRoute path='/Pagina/:pagina_id' exact component={Pagina} />
                            
                            
                            <ProtectedRoute path='/Noticia/:na_codigo' exact component={NoticiaEdit} />
                            
                            <ProtectedRoute path='/AdesaoIndividual' exact component={AdesaoIndividual} />
                            <ProtectedRoute path='/AdesaoIndividual/:adesao_individual_id' exact component={AdesaoIndividualInfo} />
                            
                            <ProtectedRoute path='/AdesaoInstitucional' exact component={AdesaoInstitucional} />
                            <ProtectedRoute path='/AdesaoInstitucional/:adesao_institucional_id' exact component={AdesaoInstitucionalInfo} />

                            <ProtectedRoute path='/Eventos' exact component={Eventos} />
                            <ProtectedRoute path='/Evento/:evento_id' exact component={Evento} />
                            <ProtectedRoute path='/Calendario' exact component={Calendario} />

                            <ProtectedRoute path='/Usuario/:usuario_id' exact component={Usuario} />
                            <ProtectedRoute path='/Usuarios' exact component={Usuarios} />

                            <ProtectedRoute path='/Biblioteca' exact component={Biblioteca} />
                            <ProtectedRoute path='/Biblioteca/:bibl_id' exact component={BibliotecaEdit} />

                            <ProtectedRoute path='/FaleConosco' exact component={FaleConosco} />
                            <ProtectedRoute path='/FaleConosco/:faleConosco_id' exact component={FaleConoscoEdit} />

                            <ProtectedRoute path='/PerfilAnual' exact component={PerfilAnual} />

                            <ProtectedRoute path='/FiqueInformado' exact component={FiqueInformado} />
                            <ProtectedRoute path='/FiqueInformado/:fiqueInformado_id' exact component={FiqueInformadoEdit} />


                            <ProtectedRoute path='/API' exact component={API} />

                            <ProtectedRoute path='/Indicadores/:desafio' exact component={Indicadores} />
                            <ProtectedRoute path='/Tokens' exact component={Tokens} />

                            <ProtectedRoute path='/Manifesto' exact component={Manifesto} />
                            <ProtectedRoute path='/GestaoMembros' exact component={GestaoMembros} />
                            <ProtectedRoute path='/HouseKeeper' exact component={HouseKeeper} />


                        </EmailVerProvider>
                        </SadtProvider>
                        </GeradoresProvider>
                        </SecaoEnunciadoProvider>
                        </VerificaDesafioProvider>
                        </EnunciadoProvider>
                        </EnergiaIdentificacaoProvider>
                        </EnergiaAquecimentoProvider>
                        </EnergiaRefrigeracaoCamProvider>
                        </EnergiaRefrigeracaoProvider>
                        </EnergiaHvacDiretaProvider>
                        </EnergiaHvacIndiretaProvider>
                        </EnergiaHvacProvider>
                        </EnergiaIluminacaoProvider>
                        </EnergiaCombustivelProvider>
                        </EnergiaGeradaProvider>
                        </EnergiaCompradaProvider>
                        </AmbienteProvider>

                    </TabelaGestaoProvider>


                </Layout>

                
                
            </Switch>

        
        </QueryClientProvider>

    )


}


export default Routes